export const countryListMapping = [
  {
    capital: 'Andorra la Vella',
    continent: 'EU',
    countryCode: 'AD',
    currency: ['EUR'],
    languages: ['ca'],
    name: 'Andorra',
    native: 'Andorra',
    phone: [376],
  },
  {
    capital: 'Abu Dhabi',
    continent: 'AS',
    countryCode: 'AE',
    currency: ['AED'],
    languages: ['ar'],
    name: 'United Arab Emirates',
    native: 'دولة الإمارات العربية المتحدة',
    phone: [971],
  },
  {
    capital: 'Kabul',
    continent: 'AS',
    countryCode: 'AF',
    currency: ['AFN'],
    languages: ['ps', 'uz', 'tk'],
    name: 'Afghanistan',
    native: 'افغانستان',
    phone: [93],
  },
  {
    capital: "Saint John's",
    continent: 'NA',
    countryCode: 'AG',
    currency: ['XCD'],
    languages: ['en'],
    name: 'Antigua and Barbuda',
    native: 'Antigua and Barbuda',
    phone: [1268],
  },
  {
    capital: 'The Valley',
    continent: 'NA',
    countryCode: 'AI',
    currency: ['XCD'],
    languages: ['en'],
    name: 'Anguilla',
    native: 'Anguilla',
    phone: [1264],
  },
  {
    capital: 'Tirana',
    continent: 'EU',
    countryCode: 'AL',
    currency: ['ALL'],
    languages: ['sq'],
    name: 'Albania',
    native: 'Shqipëria',
    phone: [355],
  },
  {
    capital: 'Yerevan',
    continent: 'AS',
    countryCode: 'AM',
    currency: ['AMD'],
    languages: ['hy', 'ru'],
    name: 'Armenia',
    native: 'Հայաստան',
    phone: [374],
  },
  {
    capital: 'Luanda',
    continent: 'AF',
    countryCode: 'AO',
    currency: ['AOA'],
    languages: ['pt'],
    name: 'Angola',
    native: 'Angola',
    phone: [244],
  },
  {
    capital: '',
    continent: 'AN',
    countryCode: 'AQ',
    currency: [],
    languages: [],
    name: 'Antarctica',
    native: 'Antarctica',
    phone: [672],
  },
  {
    capital: 'Buenos Aires',
    continent: 'SA',
    countryCode: 'AR',
    currency: ['ARS'],
    languages: ['es', 'gn'],
    name: 'Argentina',
    native: 'Argentina',
    phone: [54],
  },
  {
    capital: 'Pago Pago',
    continent: 'OC',
    countryCode: 'AS',
    currency: ['USD'],
    languages: ['en', 'sm'],
    name: 'American Samoa',
    native: 'American Samoa',
    phone: [1684],
  },
  {
    capital: 'Vienna',
    continent: 'EU',
    countryCode: 'AT',
    currency: ['EUR'],
    languages: ['de'],
    name: 'Austria',
    native: 'Österreich',
    phone: [43],
  },
  {
    capital: 'Canberra',
    continent: 'OC',
    countryCode: 'AU',
    currency: ['AUD'],
    languages: ['en'],
    name: 'Australia',
    native: 'Australia',
    phone: [61],
  },
  {
    capital: 'Oranjestad',
    continent: 'NA',
    countryCode: 'AW',
    currency: ['AWG'],
    languages: ['nl', 'pa'],
    name: 'Aruba',
    native: 'Aruba',
    phone: [297],
  },
  {
    capital: 'Mariehamn',
    continent: 'EU',
    countryCode: 'AX',
    currency: ['EUR'],
    languages: ['sv'],
    name: 'Åland',
    native: 'Åland',
    phone: [358],
  },
  {
    capital: 'Baku',
    continent: 'AS',
    continents: ['AS', 'EU'],
    countryCode: 'AZ',
    currency: ['AZN'],
    languages: ['az'],
    name: 'Azerbaijan',
    native: 'Azərbaycan',
    phone: [994],
  },
  {
    capital: 'Sarajevo',
    continent: 'EU',
    countryCode: 'BA',
    currency: ['BAM'],
    languages: ['bs', 'hr', 'sr'],
    name: 'Bosnia and Herzegovina',
    native: 'Bosna i Hercegovina',
    phone: [387],
  },
  {
    capital: 'Bridgetown',
    continent: 'NA',
    countryCode: 'BB',
    currency: ['BBD'],
    languages: ['en'],
    name: 'Barbados',
    native: 'Barbados',
    phone: [1246],
  },
  {
    capital: 'Dhaka',
    continent: 'AS',
    countryCode: 'BD',
    currency: ['BDT'],
    languages: ['bn'],
    name: 'Bangladesh',
    native: 'Bangladesh',
    phone: [880],
  },
  {
    capital: 'Brussels',
    continent: 'EU',
    countryCode: 'BE',
    currency: ['EUR'],
    languages: ['nl', 'fr', 'de'],
    name: 'Belgium',
    native: 'België',
    phone: [32],
  },
  {
    capital: 'Ouagadougou',
    continent: 'AF',
    countryCode: 'BF',
    currency: ['XOF'],
    languages: ['fr', 'ff'],
    name: 'Burkina Faso',
    native: 'Burkina Faso',
    phone: [226],
  },
  {
    capital: 'Sofia',
    continent: 'EU',
    countryCode: 'BG',
    currency: ['BGN'],
    languages: ['bg'],
    name: 'Bulgaria',
    native: 'България',
    phone: [359],
  },
  {
    capital: 'Manama',
    continent: 'AS',
    countryCode: 'BH',
    currency: ['BHD'],
    languages: ['ar'],
    name: 'Bahrain',
    native: '‏البحرين',
    phone: [973],
  },
  {
    capital: 'Bujumbura',
    continent: 'AF',
    countryCode: 'BI',
    currency: ['BIF'],
    languages: ['fr', 'rn'],
    name: 'Burundi',
    native: 'Burundi',
    phone: [257],
  },
  {
    capital: 'Porto-Novo',
    continent: 'AF',
    countryCode: 'BJ',
    currency: ['XOF'],
    languages: ['fr'],
    name: 'Benin',
    native: 'Bénin',
    phone: [229],
  },
  {
    capital: 'Gustavia',
    continent: 'NA',
    countryCode: 'BL',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'Saint Barthélemy',
    native: 'Saint-Barthélemy',
    phone: [590],
  },
  {
    capital: 'Hamilton',
    continent: 'NA',
    countryCode: 'BM',
    currency: ['BMD'],
    languages: ['en'],
    name: 'Bermuda',
    native: 'Bermuda',
    phone: [1441],
  },
  {
    capital: 'Bandar Seri Begawan',
    continent: 'AS',
    countryCode: 'BN',
    currency: ['BND'],
    languages: ['ms'],
    name: 'Brunei',
    native: 'Negara Brunei Darussalam',
    phone: [673],
  },
  {
    capital: 'Sucre',
    continent: 'SA',
    countryCode: 'BO',
    currency: ['BOB', 'BOV'],
    languages: ['es', 'ay', 'qu'],
    name: 'Bolivia',
    native: 'Bolivia',
    phone: [591],
  },
  {
    capital: 'Kralendijk',
    continent: 'NA',
    countryCode: 'BQ',
    currency: ['USD'],
    languages: ['nl'],
    name: 'Bonaire',
    native: 'Bonaire',
    phone: [5997],
  },
  {
    capital: 'Brasília',
    continent: 'SA',
    countryCode: 'BR',
    currency: ['BRL'],
    languages: ['pt'],
    name: 'Brazil',
    native: 'Brasil',
    phone: [55],
  },
  {
    capital: 'Nassau',
    continent: 'NA',
    countryCode: 'BS',
    currency: ['BSD'],
    languages: ['en'],
    name: 'Bahamas',
    native: 'Bahamas',
    phone: [1242],
  },
  {
    capital: 'Thimphu',
    continent: 'AS',
    countryCode: 'BT',
    currency: ['BTN', 'INR'],
    languages: ['dz'],
    name: 'Bhutan',
    native: 'ʼbrug-yul',
    phone: [975],
  },
  {
    capital: '',
    continent: 'AN',
    countryCode: 'BV',
    currency: ['NOK'],
    languages: ['no', 'nb', 'nn'],
    name: 'Bouvet Island',
    native: 'Bouvetøya',
    phone: [47],
  },
  {
    capital: 'Gaborone',
    continent: 'AF',
    countryCode: 'BW',
    currency: ['BWP'],
    languages: ['en', 'tn'],
    name: 'Botswana',
    native: 'Botswana',
    phone: [267],
  },
  {
    capital: 'Minsk',
    continent: 'EU',
    countryCode: 'BY',
    currency: ['BYN'],
    languages: ['be', 'ru'],
    name: 'Belarus',
    native: 'Белару́сь',
    phone: [375],
  },
  {
    capital: 'Belmopan',
    continent: 'NA',
    countryCode: 'BZ',
    currency: ['BZD'],
    languages: ['en', 'es'],
    name: 'Belize',
    native: 'Belize',
    phone: [501],
  },
  {
    capital: 'Ottawa',
    continent: 'NA',
    countryCode: 'CA',
    currency: ['CAD'],
    languages: ['en', 'fr'],
    name: 'Canada',
    native: 'Canada',
    phone: [1],
  },
  {
    capital: 'West Island',
    continent: 'AS',
    countryCode: 'CC',
    currency: ['AUD'],
    languages: ['en'],
    name: 'Cocos [Keeling] Islands',
    native: 'Cocos (Keeling) Islands',
    phone: [61],
  },
  {
    capital: 'Kinshasa',
    continent: 'AF',
    countryCode: 'CD',
    currency: ['CDF'],
    languages: ['fr', 'ln', 'kg', 'sw', 'lu'],
    name: 'Democratic Republic of the Congo',
    native: 'République démocratique du Congo',
    phone: [243],
  },
  {
    capital: 'Bangui',
    continent: 'AF',
    countryCode: 'CF',
    currency: ['XAF'],
    languages: ['fr', 'sg'],
    name: 'Central African Republic',
    native: 'Ködörösêse tî Bêafrîka',
    phone: [236],
  },
  {
    capital: 'Brazzaville',
    continent: 'AF',
    countryCode: 'CG',
    currency: ['XAF'],
    languages: ['fr', 'ln'],
    name: 'Republic of the Congo',
    native: 'République du Congo',
    phone: [242],
  },
  {
    capital: 'Bern',
    continent: 'EU',
    countryCode: 'CH',
    currency: ['CHE', 'CHF', 'CHW'],
    languages: ['de', 'fr', 'it'],
    name: 'Switzerland',
    native: 'Schweiz',
    phone: [41],
  },
  {
    capital: 'Yamoussoukro',
    continent: 'AF',
    countryCode: 'CI',
    currency: ['XOF'],
    languages: ['fr'],
    name: 'Ivory Coast',
    native: "Côte d'Ivoire",
    phone: [225],
  },
  {
    capital: 'Avarua',
    continent: 'OC',
    countryCode: 'CK',
    currency: ['NZD'],
    languages: ['en'],
    name: 'Cook Islands',
    native: 'Cook Islands',
    phone: [682],
  },
  {
    capital: 'Santiago',
    continent: 'SA',
    countryCode: 'CL',
    currency: ['CLF', 'CLP'],
    languages: ['es'],
    name: 'Chile',
    native: 'Chile',
    phone: [56],
  },
  {
    capital: 'Yaoundé',
    continent: 'AF',
    countryCode: 'CM',
    currency: ['XAF'],
    languages: ['en', 'fr'],
    name: 'Cameroon',
    native: 'Cameroon',
    phone: [237],
  },
  {
    capital: 'Beijing',
    continent: 'AS',
    countryCode: 'CN',
    currency: ['CNY'],
    languages: ['zh'],
    name: 'China',
    native: '中国',
    phone: [86],
  },
  {
    capital: 'Bogotá',
    continent: 'SA',
    countryCode: 'CO',
    currency: ['COP'],
    languages: ['es'],
    name: 'Colombia',
    native: 'Colombia',
    phone: [57],
  },
  {
    capital: 'San José',
    continent: 'NA',
    countryCode: 'CR',
    currency: ['CRC'],
    languages: ['es'],
    name: 'Costa Rica',
    native: 'Costa Rica',
    phone: [506],
  },
  {
    capital: 'Havana',
    continent: 'NA',
    countryCode: 'CU',
    currency: ['CUC', 'CUP'],
    languages: ['es'],
    name: 'Cuba',
    native: 'Cuba',
    phone: [53],
  },
  {
    capital: 'Praia',
    continent: 'AF',
    countryCode: 'CV',
    currency: ['CVE'],
    languages: ['pt'],
    name: 'Cape Verde',
    native: 'Cabo Verde',
    phone: [238],
  },
  {
    capital: 'Willemstad',
    continent: 'NA',
    countryCode: 'CW',
    currency: ['ANG'],
    languages: ['nl', 'pa', 'en'],
    name: 'Curacao',
    native: 'Curaçao',
    phone: [5999],
  },
  {
    capital: 'Flying Fish Cove',
    continent: 'AS',
    countryCode: 'CX',
    currency: ['AUD'],
    languages: ['en'],
    name: 'Christmas Island',
    native: 'Christmas Island',
    phone: [61],
  },
  {
    capital: 'Nicosia',
    continent: 'EU',
    countryCode: 'CY',
    currency: ['EUR'],
    languages: ['el', 'tr', 'hy'],
    name: 'Cyprus',
    native: 'Κύπρος',
    phone: [357],
  },
  {
    capital: 'Prague',
    continent: 'EU',
    countryCode: 'CZ',
    currency: ['CZK'],
    languages: ['cs', 'sk'],
    name: 'Czech Republic',
    native: 'Česká republika',
    phone: [420],
  },
  {
    capital: 'Berlin',
    continent: 'EU',
    countryCode: 'DE',
    currency: ['EUR'],
    languages: ['de'],
    name: 'Germany',
    native: 'Deutschland',
    phone: [49],
  },
  {
    capital: 'Djibouti',
    continent: 'AF',
    countryCode: 'DJ',
    currency: ['DJF'],
    languages: ['fr', 'ar'],
    name: 'Djibouti',
    native: 'Djibouti',
    phone: [253],
  },
  {
    capital: 'Copenhagen',
    continent: 'EU',
    continents: ['EU', 'NA'],
    countryCode: 'DK',
    currency: ['DKK'],
    languages: ['da'],
    name: 'Denmark',
    native: 'Danmark',
    phone: [45],
  },
  {
    capital: 'Roseau',
    continent: 'NA',
    countryCode: 'DM',
    currency: ['XCD'],
    languages: ['en'],
    name: 'Dominica',
    native: 'Dominica',
    phone: [1767],
  },
  {
    capital: 'Santo Domingo',
    continent: 'NA',
    countryCode: 'DO',
    currency: ['DOP'],
    languages: ['es'],
    name: 'Dominican Republic',
    native: 'República Dominicana',
    phone: [1809, 1829, 1849],
  },
  {
    capital: 'Algiers',
    continent: 'AF',
    countryCode: 'DZ',
    currency: ['DZD'],
    languages: ['ar'],
    name: 'Algeria',
    native: 'الجزائر',
    phone: [213],
  },
  {
    capital: 'Quito',
    continent: 'SA',
    countryCode: 'EC',
    currency: ['USD'],
    languages: ['es'],
    name: 'Ecuador',
    native: 'Ecuador',
    phone: [593],
  },
  {
    capital: 'Tallinn',
    continent: 'EU',
    countryCode: 'EE',
    currency: ['EUR'],
    languages: ['et'],
    name: 'Estonia',
    native: 'Eesti',
    phone: [372],
  },
  {
    capital: 'Cairo',
    continent: 'AF',
    continents: ['AF', 'AS'],
    countryCode: 'EG',
    currency: ['EGP'],
    languages: ['ar'],
    name: 'Egypt',
    native: 'مصر‎',
    phone: [20],
  },
  {
    capital: 'El Aaiún',
    continent: 'AF',
    countryCode: 'EH',
    currency: ['MAD', 'DZD', 'MRU'],
    languages: ['es'],
    name: 'Western Sahara',
    native: 'الصحراء الغربية',
    phone: [212],
  },
  {
    capital: 'Asmara',
    continent: 'AF',
    countryCode: 'ER',
    currency: ['ERN'],
    languages: ['ti', 'ar', 'en'],
    name: 'Eritrea',
    native: 'ኤርትራ',
    phone: [291],
  },
  {
    capital: 'Madrid',
    continent: 'EU',
    countryCode: 'ES',
    currency: ['EUR'],
    languages: ['es', 'eu', 'ca', 'gl', 'oc'],
    name: 'Spain',
    native: 'España',
    phone: [34],
  },
  {
    capital: 'Addis Ababa',
    continent: 'AF',
    countryCode: 'ET',
    currency: ['ETB'],
    languages: ['am'],
    name: 'Ethiopia',
    native: 'ኢትዮጵያ',
    phone: [251],
  },
  {
    capital: 'Helsinki',
    continent: 'EU',
    countryCode: 'FI',
    currency: ['EUR'],
    languages: ['fi', 'sv'],
    name: 'Finland',
    native: 'Suomi',
    phone: [358],
  },
  {
    capital: 'Suva',
    continent: 'OC',
    countryCode: 'FJ',
    currency: ['FJD'],
    languages: ['en', 'fj', 'hi', 'ur'],
    name: 'Fiji',
    native: 'Fiji',
    phone: [679],
  },
  {
    capital: 'Stanley',
    continent: 'SA',
    countryCode: 'FK',
    currency: ['FKP'],
    languages: ['en'],
    name: 'Falkland Islands',
    native: 'Falkland Islands',
    phone: [500],
  },
  {
    capital: 'Palikir',
    continent: 'OC',
    countryCode: 'FM',
    currency: ['USD'],
    languages: ['en'],
    name: 'Micronesia',
    native: 'Micronesia',
    phone: [691],
  },
  {
    capital: 'Tórshavn',
    continent: 'EU',
    countryCode: 'FO',
    currency: ['DKK'],
    languages: ['fo'],
    name: 'Faroe Islands',
    native: 'Føroyar',
    phone: [298],
  },
  {
    capital: 'Paris',
    continent: 'EU',
    countryCode: 'FR',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'France',
    native: 'France',
    phone: [33],
  },
  {
    capital: 'Libreville',
    continent: 'AF',
    countryCode: 'GA',
    currency: ['XAF'],
    languages: ['fr'],
    name: 'Gabon',
    native: 'Gabon',
    phone: [241],
  },
  {
    capital: 'London',
    continent: 'EU',
    countryCode: 'GB',
    currency: ['GBP'],
    languages: ['en'],
    name: 'United Kingdom',
    native: 'United Kingdom',
    phone: [44],
  },
  {
    capital: "St. George's",
    continent: 'NA',
    countryCode: 'GD',
    currency: ['XCD'],
    languages: ['en'],
    name: 'Grenada',
    native: 'Grenada',
    phone: [1473],
  },
  {
    capital: 'Tbilisi',
    continent: 'AS',
    countryCode: 'GE',
    currency: ['GEL'],
    languages: ['ka'],
    name: 'Georgia',
    native: 'საქართველო',
    phone: [995],
  },
  {
    capital: 'Cayenne',
    continent: 'SA',
    countryCode: 'GF',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'French Guiana',
    native: 'Guyane française',
    phone: [594],
  },
  {
    capital: 'St. Peter Port',
    continent: 'EU',
    countryCode: 'GG',
    currency: ['GBP'],
    languages: ['en', 'fr'],
    name: 'Guernsey',
    native: 'Guernsey',
    phone: [44],
  },
  {
    capital: 'Accra',
    continent: 'AF',
    countryCode: 'GH',
    currency: ['GHS'],
    languages: ['en'],
    name: 'Ghana',
    native: 'Ghana',
    phone: [233],
  },
  {
    capital: 'Gibraltar',
    continent: 'EU',
    countryCode: 'GI',
    currency: ['GIP'],
    languages: ['en'],
    name: 'Gibraltar',
    native: 'Gibraltar',
    phone: [350],
  },
  {
    capital: 'Nuuk',
    continent: 'NA',
    countryCode: 'GL',
    currency: ['DKK'],
    languages: ['kl'],
    name: 'Greenland',
    native: 'Kalaallit Nunaat',
    phone: [299],
  },
  {
    capital: 'Banjul',
    continent: 'AF',
    countryCode: 'GM',
    currency: ['GMD'],
    languages: ['en'],
    name: 'Gambia',
    native: 'Gambia',
    phone: [220],
  },
  {
    capital: 'Conakry',
    continent: 'AF',
    countryCode: 'GN',
    currency: ['GNF'],
    languages: ['fr', 'ff'],
    name: 'Guinea',
    native: 'Guinée',
    phone: [224],
  },
  {
    capital: 'Basse-Terre',
    continent: 'NA',
    countryCode: 'GP',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'Guadeloupe',
    native: 'Guadeloupe',
    phone: [590],
  },
  {
    capital: 'Malabo',
    continent: 'AF',
    countryCode: 'GQ',
    currency: ['XAF'],
    languages: ['es', 'fr'],
    name: 'Equatorial Guinea',
    native: 'Guinea Ecuatorial',
    phone: [240],
  },
  {
    capital: 'Athens',
    continent: 'EU',
    countryCode: 'GR',
    currency: ['EUR'],
    languages: ['el'],
    name: 'Greece',
    native: 'Ελλάδα',
    phone: [30],
  },
  {
    capital: 'King Edward Point',
    continent: 'AN',
    countryCode: 'GS',
    currency: ['GBP'],
    languages: ['en'],
    name: 'South Georgia and the South Sandwich Islands',
    native: 'South Georgia',
    phone: [500],
  },
  {
    capital: 'Guatemala City',
    continent: 'NA',
    countryCode: 'GT',
    currency: ['GTQ'],
    languages: ['es'],
    name: 'Guatemala',
    native: 'Guatemala',
    phone: [502],
  },
  {
    capital: 'Hagåtña',
    continent: 'OC',
    countryCode: 'GU',
    currency: ['USD'],
    languages: ['en', 'ch', 'es'],
    name: 'Guam',
    native: 'Guam',
    phone: [1671],
  },
  {
    capital: 'Bissau',
    continent: 'AF',
    countryCode: 'GW',
    currency: ['XOF'],
    languages: ['pt'],
    name: 'Guinea-Bissau',
    native: 'Guiné-Bissau',
    phone: [245],
  },
  {
    capital: 'Georgetown',
    continent: 'SA',
    countryCode: 'GY',
    currency: ['GYD'],
    languages: ['en'],
    name: 'Guyana',
    native: 'Guyana',
    phone: [592],
  },
  {
    capital: 'City of Victoria',
    continent: 'AS',
    countryCode: 'HK',
    currency: ['HKD'],
    languages: ['zh', 'en'],
    name: 'Hong Kong',
    native: '香港',
    phone: [852],
  },
  {
    capital: '',
    continent: 'AN',
    countryCode: 'HM',
    currency: ['AUD'],
    languages: ['en'],
    name: 'Heard Island and McDonald Islands',
    native: 'Heard Island and McDonald Islands',
    phone: [61],
  },
  {
    capital: 'Tegucigalpa',
    continent: 'NA',
    countryCode: 'HN',
    currency: ['HNL'],
    languages: ['es'],
    name: 'Honduras',
    native: 'Honduras',
    phone: [504],
  },
  {
    capital: 'Zagreb',
    continent: 'EU',
    countryCode: 'HR',
    currency: ['HRK'],
    languages: ['hr'],
    name: 'Croatia',
    native: 'Hrvatska',
    phone: [385],
  },
  {
    capital: 'Port-au-Prince',
    continent: 'NA',
    countryCode: 'HT',
    currency: ['HTG', 'USD'],
    languages: ['fr', 'ht'],
    name: 'Haiti',
    native: 'Haïti',
    phone: [509],
  },
  {
    capital: 'Budapest',
    continent: 'EU',
    countryCode: 'HU',
    currency: ['HUF'],
    languages: ['hu'],
    name: 'Hungary',
    native: 'Magyarország',
    phone: [36],
  },
  {
    capital: 'Jakarta',
    continent: 'AS',
    countryCode: 'ID',
    currency: ['IDR'],
    languages: ['id'],
    name: 'Indonesia',
    native: 'Indonesia',
    phone: [62],
  },
  {
    capital: 'Dublin',
    continent: 'EU',
    countryCode: 'IE',
    currency: ['EUR'],
    languages: ['ga', 'en'],
    name: 'Ireland',
    native: 'Éire',
    phone: [353],
  },
  {
    capital: 'Jerusalem',
    continent: 'AS',
    countryCode: 'IL',
    currency: ['ILS'],
    languages: ['he', 'ar'],
    name: 'Israel',
    native: 'יִשְׂרָאֵל',
    phone: [972],
  },
  {
    capital: 'Douglas',
    continent: 'EU',
    countryCode: 'IM',
    currency: ['GBP'],
    languages: ['en', 'gv'],
    name: 'Isle of Man',
    native: 'Isle of Man',
    phone: [44],
  },
  {
    capital: 'New Delhi',
    continent: 'AS',
    countryCode: 'IN',
    currency: ['INR'],
    languages: ['hi', 'en'],
    name: 'India',
    native: 'भारत',
    phone: [91],
  },
  {
    capital: 'Diego Garcia',
    continent: 'AS',
    countryCode: 'IO',
    currency: ['USD'],
    languages: ['en'],
    name: 'British Indian Ocean Territory',
    native: 'British Indian Ocean Territory',
    phone: [246],
  },
  {
    capital: 'Baghdad',
    continent: 'AS',
    countryCode: 'IQ',
    currency: ['IQD'],
    languages: ['ar', 'ku'],
    name: 'Iraq',
    native: 'العراق',
    phone: [964],
  },
  {
    capital: 'Tehran',
    continent: 'AS',
    countryCode: 'IR',
    currency: ['IRR'],
    languages: ['fa'],
    name: 'Iran',
    native: 'ایران',
    phone: [98],
  },
  {
    capital: 'Reykjavik',
    continent: 'EU',
    countryCode: 'IS',
    currency: ['ISK'],
    languages: ['is'],
    name: 'Iceland',
    native: 'Ísland',
    phone: [354],
  },
  {
    capital: 'Rome',
    continent: 'EU',
    countryCode: 'IT',
    currency: ['EUR'],
    languages: ['it'],
    name: 'Italy',
    native: 'Italia',
    phone: [39],
  },
  {
    capital: 'Saint Helier',
    continent: 'EU',
    countryCode: 'JE',
    currency: ['GBP'],
    languages: ['en', 'fr'],
    name: 'Jersey',
    native: 'Jersey',
    phone: [44],
  },
  {
    capital: 'Kingston',
    continent: 'NA',
    countryCode: 'JM',
    currency: ['JMD'],
    languages: ['en'],
    name: 'Jamaica',
    native: 'Jamaica',
    phone: [1876],
  },
  {
    capital: 'Amman',
    continent: 'AS',
    countryCode: 'JO',
    currency: ['JOD'],
    languages: ['ar'],
    name: 'Jordan',
    native: 'الأردن',
    phone: [962],
  },
  {
    capital: 'Tokyo',
    continent: 'AS',
    countryCode: 'JP',
    currency: ['JPY'],
    languages: ['ja'],
    name: 'Japan',
    native: '日本',
    phone: [81],
  },
  {
    capital: 'Nairobi',
    continent: 'AF',
    countryCode: 'KE',
    currency: ['KES'],
    languages: ['en', 'sw'],
    name: 'Kenya',
    native: 'Kenya',
    phone: [254],
  },
  {
    capital: 'Bishkek',
    continent: 'AS',
    countryCode: 'KG',
    currency: ['KGS'],
    languages: ['ky', 'ru'],
    name: 'Kyrgyzstan',
    native: 'Кыргызстан',
    phone: [996],
  },
  {
    capital: 'Phnom Penh',
    continent: 'AS',
    countryCode: 'KH',
    currency: ['KHR'],
    languages: ['km'],
    name: 'Cambodia',
    native: 'Kâmpŭchéa',
    phone: [855],
  },
  {
    capital: 'South Tarawa',
    continent: 'OC',
    countryCode: 'KI',
    currency: ['AUD'],
    languages: ['en'],
    name: 'Kiribati',
    native: 'Kiribati',
    phone: [686],
  },
  {
    capital: 'Moroni',
    continent: 'AF',
    countryCode: 'KM',
    currency: ['KMF'],
    languages: ['ar', 'fr'],
    name: 'Comoros',
    native: 'Komori',
    phone: [269],
  },
  {
    capital: 'Basseterre',
    continent: 'NA',
    countryCode: 'KN',
    currency: ['XCD'],
    languages: ['en'],
    name: 'Saint Kitts and Nevis',
    native: 'Saint Kitts and Nevis',
    phone: [1869],
  },
  {
    capital: 'Pyongyang',
    continent: 'AS',
    countryCode: 'KP',
    currency: ['KPW'],
    languages: ['ko'],
    name: 'North Korea',
    native: '북한',
    phone: [850],
  },
  {
    capital: 'Seoul',
    continent: 'AS',
    countryCode: 'KR',
    currency: ['KRW'],
    languages: ['ko'],
    name: 'South Korea',
    native: '대한민국',
    phone: [82],
  },
  {
    capital: 'Kuwait City',
    continent: 'AS',
    countryCode: 'KW',
    currency: ['KWD'],
    languages: ['ar'],
    name: 'Kuwait',
    native: 'الكويت',
    phone: [965],
  },
  {
    capital: 'George Town',
    continent: 'NA',
    countryCode: 'KY',
    currency: ['KYD'],
    languages: ['en'],
    name: 'Cayman Islands',
    native: 'Cayman Islands',
    phone: [1345],
  },
  {
    capital: 'Astana',
    continent: 'AS',
    continents: ['AS', 'EU'],
    countryCode: 'KZ',
    currency: ['KZT'],
    languages: ['kk', 'ru'],
    name: 'Kazakhstan',
    native: 'Қазақстан',
    phone: [76, 77],
  },
  {
    capital: 'Vientiane',
    continent: 'AS',
    countryCode: 'LA',
    currency: ['LAK'],
    languages: ['lo'],
    name: 'Laos',
    native: 'ສປປລາວ',
    phone: [856],
  },
  {
    capital: 'Beirut',
    continent: 'AS',
    countryCode: 'LB',
    currency: ['LBP'],
    languages: ['ar', 'fr'],
    name: 'Lebanon',
    native: 'لبنان',
    phone: [961],
  },
  {
    capital: 'Castries',
    continent: 'NA',
    countryCode: 'LC',
    currency: ['XCD'],
    languages: ['en'],
    name: 'Saint Lucia',
    native: 'Saint Lucia',
    phone: [1758],
  },
  {
    capital: 'Vaduz',
    continent: 'EU',
    countryCode: 'LI',
    currency: ['CHF'],
    languages: ['de'],
    name: 'Liechtenstein',
    native: 'Liechtenstein',
    phone: [423],
  },
  {
    capital: 'Colombo',
    continent: 'AS',
    countryCode: 'LK',
    currency: ['LKR'],
    languages: ['si', 'ta'],
    name: 'Sri Lanka',
    native: 'śrī laṃkāva',
    phone: [94],
  },
  {
    capital: 'Monrovia',
    continent: 'AF',
    countryCode: 'LR',
    currency: ['LRD'],
    languages: ['en'],
    name: 'Liberia',
    native: 'Liberia',
    phone: [231],
  },
  {
    capital: 'Maseru',
    continent: 'AF',
    countryCode: 'LS',
    currency: ['LSL', 'ZAR'],
    languages: ['en', 'st'],
    name: 'Lesotho',
    native: 'Lesotho',
    phone: [266],
  },
  {
    capital: 'Vilnius',
    continent: 'EU',
    countryCode: 'LT',
    currency: ['EUR'],
    languages: ['lt'],
    name: 'Lithuania',
    native: 'Lietuva',
    phone: [370],
  },
  {
    capital: 'Luxembourg',
    continent: 'EU',
    countryCode: 'LU',
    currency: ['EUR'],
    languages: ['fr', 'de', 'lb'],
    name: 'Luxembourg',
    native: 'Luxembourg',
    phone: [352],
  },
  {
    capital: 'Riga',
    continent: 'EU',
    countryCode: 'LV',
    currency: ['EUR'],
    languages: ['lv'],
    name: 'Latvia',
    native: 'Latvija',
    phone: [371],
  },
  {
    capital: 'Tripoli',
    continent: 'AF',
    countryCode: 'LY',
    currency: ['LYD'],
    languages: ['ar'],
    name: 'Libya',
    native: '‏ليبيا',
    phone: [218],
  },
  {
    capital: 'Rabat',
    continent: 'AF',
    countryCode: 'MA',
    currency: ['MAD'],
    languages: ['ar'],
    name: 'Morocco',
    native: 'المغرب',
    phone: [212],
  },
  {
    capital: 'Monaco',
    continent: 'EU',
    countryCode: 'MC',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'Monaco',
    native: 'Monaco',
    phone: [377],
  },
  {
    capital: 'Chișinău',
    continent: 'EU',
    countryCode: 'MD',
    currency: ['MDL'],
    languages: ['ro'],
    name: 'Moldova',
    native: 'Moldova',
    phone: [373],
  },
  {
    capital: 'Podgorica',
    continent: 'EU',
    countryCode: 'ME',
    currency: ['EUR'],
    languages: ['sr', 'bs', 'sq', 'hr'],
    name: 'Montenegro',
    native: 'Црна Гора',
    phone: [382],
  },
  {
    capital: 'Marigot',
    continent: 'NA',
    countryCode: 'MF',
    currency: ['EUR'],
    languages: ['en', 'fr', 'nl'],
    name: 'Saint Martin',
    native: 'Saint-Martin',
    phone: [590],
  },
  {
    capital: 'Antananarivo',
    continent: 'AF',
    countryCode: 'MG',
    currency: ['MGA'],
    languages: ['fr', 'mg'],
    name: 'Madagascar',
    native: 'Madagasikara',
    phone: [261],
  },
  {
    capital: 'Majuro',
    continent: 'OC',
    countryCode: 'MH',
    currency: ['USD'],
    languages: ['en', 'mh'],
    name: 'Marshall Islands',
    native: 'M̧ajeļ',
    phone: [692],
  },
  {
    capital: 'Skopje',
    continent: 'EU',
    countryCode: 'MK',
    currency: ['MKD'],
    languages: ['mk'],
    name: 'North Macedonia',
    native: 'Северна Македонија',
    phone: [389],
  },
  {
    capital: 'Bamako',
    continent: 'AF',
    countryCode: 'ML',
    currency: ['XOF'],
    languages: ['fr'],
    name: 'Mali',
    native: 'Mali',
    phone: [223],
  },
  {
    capital: 'Naypyidaw',
    continent: 'AS',
    countryCode: 'MM',
    currency: ['MMK'],
    languages: ['my'],
    name: 'Myanmar [Burma]',
    native: 'မြန်မာ',
    phone: [95],
  },
  {
    capital: 'Ulan Bator',
    continent: 'AS',
    countryCode: 'MN',
    currency: ['MNT'],
    languages: ['mn'],
    name: 'Mongolia',
    native: 'Монгол улс',
    phone: [976],
  },
  {
    capital: '',
    continent: 'AS',
    countryCode: 'MO',
    currency: ['MOP'],
    languages: ['zh', 'pt'],
    name: 'Macao',
    native: '澳門',
    phone: [853],
  },
  {
    capital: 'Saipan',
    continent: 'OC',
    countryCode: 'MP',
    currency: ['USD'],
    languages: ['en', 'ch'],
    name: 'Northern Mariana Islands',
    native: 'Northern Mariana Islands',
    phone: [1670],
  },
  {
    capital: 'Fort-de-France',
    continent: 'NA',
    countryCode: 'MQ',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'Martinique',
    native: 'Martinique',
    phone: [596],
  },
  {
    capital: 'Nouakchott',
    continent: 'AF',
    countryCode: 'MR',
    currency: ['MRU'],
    languages: ['ar'],
    name: 'Mauritania',
    native: 'موريتانيا',
    phone: [222],
  },
  {
    capital: 'Plymouth',
    continent: 'NA',
    countryCode: 'MS',
    currency: ['XCD'],
    languages: ['en'],
    name: 'Montserrat',
    native: 'Montserrat',
    phone: [1664],
  },
  {
    capital: 'Valletta',
    continent: 'EU',
    countryCode: 'MT',
    currency: ['EUR'],
    languages: ['mt', 'en'],
    name: 'Malta',
    native: 'Malta',
    phone: [356],
  },
  {
    capital: 'Port Louis',
    continent: 'AF',
    countryCode: 'MU',
    currency: ['MUR'],
    languages: ['en'],
    name: 'Mauritius',
    native: 'Maurice',
    phone: [230],
  },
  {
    capital: 'Malé',
    continent: 'AS',
    countryCode: 'MV',
    currency: ['MVR'],
    languages: ['dv'],
    name: 'Maldives',
    native: 'Maldives',
    phone: [960],
  },
  {
    capital: 'Lilongwe',
    continent: 'AF',
    countryCode: 'MW',
    currency: ['MWK'],
    languages: ['en', 'ny'],
    name: 'Malawi',
    native: 'Malawi',
    phone: [265],
  },
  {
    capital: 'Mexico City',
    continent: 'NA',
    countryCode: 'MX',
    currency: ['MXN'],
    languages: ['es'],
    name: 'Mexico',
    native: 'México',
    phone: [52],
  },
  {
    capital: 'Kuala Lumpur',
    continent: 'AS',
    countryCode: 'MY',
    currency: ['MYR'],
    languages: ['ms'],
    name: 'Malaysia',
    native: 'Malaysia',
    phone: [60],
  },
  {
    capital: 'Maputo',
    continent: 'AF',
    countryCode: 'MZ',
    currency: ['MZN'],
    languages: ['pt'],
    name: 'Mozambique',
    native: 'Moçambique',
    phone: [258],
  },
  {
    capital: 'Windhoek',
    continent: 'AF',
    countryCode: 'NA',
    currency: ['NAD', 'ZAR'],
    languages: ['en', 'af'],
    name: 'Namibia',
    native: 'Namibia',
    phone: [264],
  },
  {
    capital: 'Nouméa',
    continent: 'OC',
    countryCode: 'NC',
    currency: ['XPF'],
    languages: ['fr'],
    name: 'New Caledonia',
    native: 'Nouvelle-Calédonie',
    phone: [687],
  },
  {
    capital: 'Niamey',
    continent: 'AF',
    countryCode: 'NE',
    currency: ['XOF'],
    languages: ['fr'],
    name: 'Niger',
    native: 'Niger',
    phone: [227],
  },
  {
    capital: 'Kingston',
    continent: 'OC',
    countryCode: 'NF',
    currency: ['AUD'],
    languages: ['en'],
    name: 'Norfolk Island',
    native: 'Norfolk Island',
    phone: [672],
  },
  {
    capital: 'Abuja',
    continent: 'AF',
    countryCode: 'NG',
    currency: ['NGN'],
    languages: ['en'],
    name: 'Nigeria',
    native: 'Nigeria',
    phone: [234],
  },
  {
    capital: 'Managua',
    continent: 'NA',
    countryCode: 'NI',
    currency: ['NIO'],
    languages: ['es'],
    name: 'Nicaragua',
    native: 'Nicaragua',
    phone: [505],
  },
  {
    capital: 'Amsterdam',
    continent: 'EU',
    countryCode: 'NL',
    currency: ['EUR'],
    languages: ['nl'],
    name: 'Netherlands',
    native: 'Nederland',
    phone: [31],
  },
  {
    capital: 'Oslo',
    continent: 'EU',
    countryCode: 'NO',
    currency: ['NOK'],
    languages: ['no', 'nb', 'nn'],
    name: 'Norway',
    native: 'Norge',
    phone: [47],
  },
  {
    capital: 'Kathmandu',
    continent: 'AS',
    countryCode: 'NP',
    currency: ['NPR'],
    languages: ['ne'],
    name: 'Nepal',
    native: 'नपल',
    phone: [977],
  },
  {
    capital: 'Yaren',
    continent: 'OC',
    countryCode: 'NR',
    currency: ['AUD'],
    languages: ['en', 'na'],
    name: 'Nauru',
    native: 'Nauru',
    phone: [674],
  },
  {
    capital: 'Alofi',
    continent: 'OC',
    countryCode: 'NU',
    currency: ['NZD'],
    languages: ['en'],
    name: 'Niue',
    native: 'Niuē',
    phone: [683],
  },
  {
    capital: 'Wellington',
    continent: 'OC',
    countryCode: 'NZ',
    currency: ['NZD'],
    languages: ['en', 'mi'],
    name: 'New Zealand',
    native: 'New Zealand',
    phone: [64],
  },
  {
    capital: 'Muscat',
    continent: 'AS',
    countryCode: 'OM',
    currency: ['OMR'],
    languages: ['ar'],
    name: 'Oman',
    native: 'عمان',
    phone: [968],
  },
  {
    capital: 'Panama City',
    continent: 'NA',
    countryCode: 'PA',
    currency: ['PAB', 'USD'],
    languages: ['es'],
    name: 'Panama',
    native: 'Panamá',
    phone: [507],
  },
  {
    capital: 'Lima',
    continent: 'SA',
    countryCode: 'PE',
    currency: ['PEN'],
    languages: ['es'],
    name: 'Peru',
    native: 'Perú',
    phone: [51],
  },
  {
    capital: 'Papeetē',
    continent: 'OC',
    countryCode: 'PF',
    currency: ['XPF'],
    languages: ['fr'],
    name: 'French Polynesia',
    native: 'Polynésie française',
    phone: [689],
  },
  {
    capital: 'Port Moresby',
    continent: 'OC',
    countryCode: 'PG',
    currency: ['PGK'],
    languages: ['en'],
    name: 'Papua New Guinea',
    native: 'Papua Niugini',
    phone: [675],
  },
  {
    capital: 'Manila',
    continent: 'AS',
    countryCode: 'PH',
    currency: ['PHP'],
    languages: ['en'],
    name: 'Philippines',
    native: 'Pilipinas',
    phone: [63],
  },
  {
    capital: 'Islamabad',
    continent: 'AS',
    countryCode: 'PK',
    currency: ['PKR'],
    languages: ['en', 'ur'],
    name: 'Pakistan',
    native: 'Pakistan',
    phone: [92],
  },
  {
    capital: 'Warsaw',
    continent: 'EU',
    countryCode: 'PL',
    currency: ['PLN'],
    languages: ['pl'],
    name: 'Poland',
    native: 'Polska',
    phone: [48],
  },
  {
    capital: 'Saint-Pierre',
    continent: 'NA',
    countryCode: 'PM',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'Saint Pierre and Miquelon',
    native: 'Saint-Pierre-et-Miquelon',
    phone: [508],
  },
  {
    capital: 'Adamstown',
    continent: 'OC',
    countryCode: 'PN',
    currency: ['NZD'],
    languages: ['en'],
    name: 'Pitcairn Islands',
    native: 'Pitcairn Islands',
    phone: [64],
  },
  {
    capital: 'San Juan',
    continent: 'NA',
    countryCode: 'PR',
    currency: ['USD'],
    languages: ['es', 'en'],
    name: 'Puerto Rico',
    native: 'Puerto Rico',
    phone: [1787, 1939],
  },
  {
    capital: 'Ramallah',
    continent: 'AS',
    countryCode: 'PS',
    currency: ['ILS'],
    languages: ['ar'],
    name: 'Palestine',
    native: 'فلسطين',
    phone: [970],
  },
  {
    capital: 'Lisbon',
    continent: 'EU',
    countryCode: 'PT',
    currency: ['EUR'],
    languages: ['pt'],
    name: 'Portugal',
    native: 'Portugal',
    phone: [351],
  },
  {
    capital: 'Ngerulmud',
    continent: 'OC',
    countryCode: 'PW',
    currency: ['USD'],
    languages: ['en'],
    name: 'Palau',
    native: 'Palau',
    phone: [680],
  },
  {
    capital: 'Asunción',
    continent: 'SA',
    countryCode: 'PY',
    currency: ['PYG'],
    languages: ['es', 'gn'],
    name: 'Paraguay',
    native: 'Paraguay',
    phone: [595],
  },
  {
    capital: 'Doha',
    continent: 'AS',
    countryCode: 'QA',
    currency: ['QAR'],
    languages: ['ar'],
    name: 'Qatar',
    native: 'قطر',
    phone: [974],
  },
  {
    capital: 'Saint-Denis',
    continent: 'AF',
    countryCode: 'RE',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'Réunion',
    native: 'La Réunion',
    phone: [262],
  },
  {
    capital: 'Bucharest',
    continent: 'EU',
    countryCode: 'RO',
    currency: ['RON'],
    languages: ['ro'],
    name: 'Romania',
    native: 'România',
    phone: [40],
  },
  {
    capital: 'Belgrade',
    continent: 'EU',
    countryCode: 'RS',
    currency: ['RSD'],
    languages: ['sr'],
    name: 'Serbia',
    native: 'Србија',
    phone: [381],
  },
  {
    capital: 'Moscow',
    continent: 'EU',
    continents: ['AS', 'EU'],
    countryCode: 'RU',
    currency: ['RUB'],
    languages: ['ru'],
    name: 'Russia',
    native: 'Россия',
    phone: [7],
  },
  {
    capital: 'Kigali',
    continent: 'AF',
    countryCode: 'RW',
    currency: ['RWF'],
    languages: ['rw', 'en', 'fr'],
    name: 'Rwanda',
    native: 'Rwanda',
    phone: [250],
  },
  {
    capital: 'Riyadh',
    continent: 'AS',
    countryCode: 'SA',
    currency: ['SAR'],
    languages: ['ar'],
    name: 'Saudi Arabia',
    native: 'العربية السعودية',
    phone: [966],
  },
  {
    capital: 'Honiara',
    continent: 'OC',
    countryCode: 'SB',
    currency: ['SBD'],
    languages: ['en'],
    name: 'Solomon Islands',
    native: 'Solomon Islands',
    phone: [677],
  },
  {
    capital: 'Victoria',
    continent: 'AF',
    countryCode: 'SC',
    currency: ['SCR'],
    languages: ['fr', 'en'],
    name: 'Seychelles',
    native: 'Seychelles',
    phone: [248],
  },
  {
    capital: 'Khartoum',
    continent: 'AF',
    countryCode: 'SD',
    currency: ['SDG'],
    languages: ['ar', 'en'],
    name: 'Sudan',
    native: 'السودان',
    phone: [249],
  },
  {
    capital: 'Stockholm',
    continent: 'EU',
    countryCode: 'SE',
    currency: ['SEK'],
    languages: ['sv'],
    name: 'Sweden',
    native: 'Sverige',
    phone: [46],
  },
  {
    capital: 'Singapore',
    continent: 'AS',
    countryCode: 'SG',
    currency: ['SGD'],
    languages: ['en', 'ms', 'ta', 'zh'],
    name: 'Singapore',
    native: 'Singapore',
    phone: [65],
  },
  {
    capital: 'Jamestown',
    continent: 'AF',
    countryCode: 'SH',
    currency: ['SHP'],
    languages: ['en'],
    name: 'Saint Helena',
    native: 'Saint Helena',
    phone: [290],
  },
  {
    capital: 'Ljubljana',
    continent: 'EU',
    countryCode: 'SI',
    currency: ['EUR'],
    languages: ['sl'],
    name: 'Slovenia',
    native: 'Slovenija',
    phone: [386],
  },
  {
    capital: 'Longyearbyen',
    continent: 'EU',
    countryCode: 'SJ',
    currency: ['NOK'],
    languages: ['no'],
    name: 'Svalbard and Jan Mayen',
    native: 'Svalbard og Jan Mayen',
    phone: [4779],
  },
  {
    capital: 'Bratislava',
    continent: 'EU',
    countryCode: 'SK',
    currency: ['EUR'],
    languages: ['sk'],
    name: 'Slovakia',
    native: 'Slovensko',
    phone: [421],
  },
  {
    capital: 'Freetown',
    continent: 'AF',
    countryCode: 'SL',
    currency: ['SLL'],
    languages: ['en'],
    name: 'Sierra Leone',
    native: 'Sierra Leone',
    phone: [232],
  },
  {
    capital: 'City of San Marino',
    continent: 'EU',
    countryCode: 'SM',
    currency: ['EUR'],
    languages: ['it'],
    name: 'San Marino',
    native: 'San Marino',
    phone: [378],
  },
  {
    capital: 'Dakar',
    continent: 'AF',
    countryCode: 'SN',
    currency: ['XOF'],
    languages: ['fr'],
    name: 'Senegal',
    native: 'Sénégal',
    phone: [221],
  },
  {
    capital: 'Mogadishu',
    continent: 'AF',
    countryCode: 'SO',
    currency: ['SOS'],
    languages: ['so', 'ar'],
    name: 'Somalia',
    native: 'Soomaaliya',
    phone: [252],
  },
  {
    capital: 'Paramaribo',
    continent: 'SA',
    countryCode: 'SR',
    currency: ['SRD'],
    languages: ['nl'],
    name: 'Suriname',
    native: 'Suriname',
    phone: [597],
  },
  {
    capital: 'Juba',
    continent: 'AF',
    countryCode: 'SS',
    currency: ['SSP'],
    languages: ['en'],
    name: 'South Sudan',
    native: 'South Sudan',
    phone: [211],
  },
  {
    capital: 'São Tomé',
    continent: 'AF',
    countryCode: 'ST',
    currency: ['STN'],
    languages: ['pt'],
    name: 'São Tomé and Príncipe',
    native: 'São Tomé e Príncipe',
    phone: [239],
  },
  {
    capital: 'San Salvador',
    continent: 'NA',
    countryCode: 'SV',
    currency: ['SVC', 'USD'],
    languages: ['es'],
    name: 'El Salvador',
    native: 'El Salvador',
    phone: [503],
  },
  {
    capital: 'Philipsburg',
    continent: 'NA',
    countryCode: 'SX',
    currency: ['ANG'],
    languages: ['nl', 'en'],
    name: 'Sint Maarten',
    native: 'Sint Maarten',
    phone: [1721],
  },
  {
    capital: 'Damascus',
    continent: 'AS',
    countryCode: 'SY',
    currency: ['SYP'],
    languages: ['ar'],
    name: 'Syria',
    native: 'سوريا',
    phone: [963],
  },
  {
    capital: 'Lobamba',
    continent: 'AF',
    countryCode: 'SZ',
    currency: ['SZL'],
    languages: ['en', 'ss'],
    name: 'Swaziland',
    native: 'Swaziland',
    phone: [268],
  },
  {
    capital: 'Cockburn Town',
    continent: 'NA',
    countryCode: 'TC',
    currency: ['USD'],
    languages: ['en'],
    name: 'Turks and Caicos Islands',
    native: 'Turks and Caicos Islands',
    phone: [1649],
  },
  {
    capital: "N'Djamena",
    continent: 'AF',
    countryCode: 'TD',
    currency: ['XAF'],
    languages: ['fr', 'ar'],
    name: 'Chad',
    native: 'Tchad',
    phone: [235],
  },
  {
    capital: 'Port-aux-Français',
    continent: 'AN',
    countryCode: 'TF',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'French Southern Territories',
    native: 'Territoire des Terres australes et antarctiques fr',
    phone: [262],
  },
  {
    capital: 'Lomé',
    continent: 'AF',
    countryCode: 'TG',
    currency: ['XOF'],
    languages: ['fr'],
    name: 'Togo',
    native: 'Togo',
    phone: [228],
  },
  {
    capital: 'Bangkok',
    continent: 'AS',
    countryCode: 'TH',
    currency: ['THB'],
    languages: ['th'],
    name: 'Thailand',
    native: 'ประเทศไทย',
    phone: [66],
  },
  {
    capital: 'Dushanbe',
    continent: 'AS',
    countryCode: 'TJ',
    currency: ['TJS'],
    languages: ['tg', 'ru'],
    name: 'Tajikistan',
    native: 'Тоҷикистон',
    phone: [992],
  },
  {
    capital: 'Fakaofo',
    continent: 'OC',
    countryCode: 'TK',
    currency: ['NZD'],
    languages: ['en'],
    name: 'Tokelau',
    native: 'Tokelau',
    phone: [690],
  },
  {
    capital: 'Dili',
    continent: 'OC',
    countryCode: 'TL',
    currency: ['USD'],
    languages: ['pt'],
    name: 'East Timor',
    native: 'Timor-Leste',
    phone: [670],
  },
  {
    capital: 'Ashgabat',
    continent: 'AS',
    countryCode: 'TM',
    currency: ['TMT'],
    languages: ['tk', 'ru'],
    name: 'Turkmenistan',
    native: 'Türkmenistan',
    phone: [993],
  },
  {
    capital: 'Tunis',
    continent: 'AF',
    countryCode: 'TN',
    currency: ['TND'],
    languages: ['ar'],
    name: 'Tunisia',
    native: 'تونس',
    phone: [216],
  },
  {
    capital: "Nuku'alofa",
    continent: 'OC',
    countryCode: 'TO',
    currency: ['TOP'],
    languages: ['en', 'to'],
    name: 'Tonga',
    native: 'Tonga',
    phone: [676],
  },
  {
    capital: 'Ankara',
    continent: 'AS',
    continents: ['AS', 'EU'],
    countryCode: 'TR',
    currency: ['TRY'],
    languages: ['tr'],
    name: 'Turkey',
    native: 'Türkiye',
    phone: [90],
  },
  {
    capital: 'Port of Spain',
    continent: 'NA',
    countryCode: 'TT',
    currency: ['TTD'],
    languages: ['en'],
    name: 'Trinidad and Tobago',
    native: 'Trinidad and Tobago',
    phone: [1868],
  },
  {
    capital: 'Funafuti',
    continent: 'OC',
    countryCode: 'TV',
    currency: ['AUD'],
    languages: ['en'],
    name: 'Tuvalu',
    native: 'Tuvalu',
    phone: [688],
  },
  {
    capital: 'Taipei',
    continent: 'AS',
    countryCode: 'TW',
    currency: ['TWD'],
    languages: ['zh'],
    name: 'Taiwan',
    native: '臺灣',
    phone: [886],
  },
  {
    capital: 'Dodoma',
    continent: 'AF',
    countryCode: 'TZ',
    currency: ['TZS'],
    languages: ['sw', 'en'],
    name: 'Tanzania',
    native: 'Tanzania',
    phone: [255],
  },
  {
    capital: 'Kyiv',
    continent: 'EU',
    countryCode: 'UA',
    currency: ['UAH'],
    languages: ['uk'],
    name: 'Ukraine',
    native: 'Україна',
    phone: [380],
  },
  {
    capital: 'Kampala',
    continent: 'AF',
    countryCode: 'UG',
    currency: ['UGX'],
    languages: ['en', 'sw'],
    name: 'Uganda',
    native: 'Uganda',
    phone: [256],
  },
  {
    capital: '',
    continent: 'OC',
    countryCode: 'UM',
    currency: ['USD'],
    languages: ['en'],
    name: 'U.S. Minor Outlying Islands',
    native: 'United States Minor Outlying Islands',
    phone: [1],
  },
  {
    capital: 'Washington D.C.',
    continent: 'NA',
    countryCode: 'US',
    currency: ['USD', 'USN', 'USS'],
    languages: ['en'],
    name: 'United States',
    native: 'United States',
    phone: [1],
  },
  {
    capital: 'Montevideo',
    continent: 'SA',
    countryCode: 'UY',
    currency: ['UYI', 'UYU'],
    languages: ['es'],
    name: 'Uruguay',
    native: 'Uruguay',
    phone: [598],
  },
  {
    capital: 'Tashkent',
    continent: 'AS',
    countryCode: 'UZ',
    currency: ['UZS'],
    languages: ['uz', 'ru'],
    name: 'Uzbekistan',
    native: 'O‘zbekiston',
    phone: [998],
  },
  {
    capital: 'Vatican City',
    continent: 'EU',
    countryCode: 'VA',
    currency: ['EUR'],
    languages: ['it', 'la'],
    name: 'Vatican City',
    native: 'Vaticano',
    phone: [379],
  },
  {
    capital: 'Kingstown',
    continent: 'NA',
    countryCode: 'VC',
    currency: ['XCD'],
    languages: ['en'],
    name: 'Saint Vincent and the Grenadines',
    native: 'Saint Vincent and the Grenadines',
    phone: [1784],
  },
  {
    capital: 'Caracas',
    continent: 'SA',
    countryCode: 'VE',
    currency: ['VES'],
    languages: ['es'],
    name: 'Venezuela',
    native: 'Venezuela',
    phone: [58],
  },
  {
    capital: 'Road Town',
    continent: 'NA',
    countryCode: 'VG',
    currency: ['USD'],
    languages: ['en'],
    name: 'British Virgin Islands',
    native: 'British Virgin Islands',
    phone: [1284],
  },
  {
    capital: 'Charlotte Amalie',
    continent: 'NA',
    countryCode: 'VI',
    currency: ['USD'],
    languages: ['en'],
    name: 'U.S. Virgin Islands',
    native: 'United States Virgin Islands',
    phone: [1340],
  },
  {
    capital: 'Hanoi',
    continent: 'AS',
    countryCode: 'VN',
    currency: ['VND'],
    languages: ['vi'],
    name: 'Vietnam',
    native: 'Việt Nam',
    phone: [84],
  },
  {
    capital: 'Port Vila',
    continent: 'OC',
    countryCode: 'VU',
    currency: ['VUV'],
    languages: ['bi', 'en', 'fr'],
    name: 'Vanuatu',
    native: 'Vanuatu',
    phone: [678],
  },
  {
    capital: 'Mata-Utu',
    continent: 'OC',
    countryCode: 'WF',
    currency: ['XPF'],
    languages: ['fr'],
    name: 'Wallis and Futuna',
    native: 'Wallis et Futuna',
    phone: [681],
  },
  {
    capital: 'Apia',
    continent: 'OC',
    countryCode: 'WS',
    currency: ['WST'],
    languages: ['sm', 'en'],
    name: 'Samoa',
    native: 'Samoa',
    phone: [685],
  },
  {
    capital: 'Pristina',
    continent: 'EU',
    countryCode: 'XK',
    currency: ['EUR'],
    languages: ['sq', 'sr'],
    name: 'Kosovo',
    native: 'Republika e Kosovës',
    phone: [377, 381, 383, 386],
  },
  {
    capital: "Sana'a",
    continent: 'AS',
    countryCode: 'YE',
    currency: ['YER'],
    languages: ['ar'],
    name: 'Yemen',
    native: 'اليَمَن',
    phone: [967],
  },
  {
    capital: 'Mamoudzou',
    continent: 'AF',
    countryCode: 'YT',
    currency: ['EUR'],
    languages: ['fr'],
    name: 'Mayotte',
    native: 'Mayotte',
    phone: [262],
  },
  {
    capital: 'Pretoria',
    continent: 'AF',
    countryCode: 'ZA',
    currency: ['ZAR'],
    languages: ['af', 'en', 'nr', 'st', 'ss', 'tn', 'ts', 've', 'xh', 'zu'],
    name: 'South Africa',
    native: 'South Africa',
    phone: [27],
  },
  {
    capital: 'Lusaka',
    continent: 'AF',
    countryCode: 'ZM',
    currency: ['ZMW'],
    languages: ['en'],
    name: 'Zambia',
    native: 'Zambia',
    phone: [260],
  },
  {
    capital: 'Harare',
    continent: 'AF',
    countryCode: 'ZW',
    currency: ['USD', 'ZAR', 'BWP', 'GBP', 'AUD', 'CNY', 'INR', 'JPY'],
    languages: ['en', 'sn', 'nd'],
    name: 'Zimbabwe',
    native: 'Zimbabwe',
    phone: [263],
  },
];
